import { useState, useCallback, useMemo } from 'react';
import * as Yup from 'yup';

import { useLazyGetFilterOptionsQuery } from '../../../../../../services/contacts';

export const useIndustryFilter = ({ sharedList, orderBy, setFilters }) => {
  const [getFilterOptions] = useLazyGetFilterOptionsQuery();
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const industryYearsOptions = useMemo(
    () => [
      { label: '2 or more years', value: 2 },
      { label: '5 or more years', value: 5 },
      { label: '10 or more years', value: 10 },
    ],
    [],
  );

  const formSchema = Yup.object().shape({
    industryTags: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      }),
    ),
    industryTagsYears: Yup.object()
      .shape({
        label: Yup.string(),
        value: Yup.number(),
      })
      .nullable()
      .default(null),
  });

  const onSearchChange = async (currentValue) => {
    try {
      const data = await getFilterOptions({
        facet: 'industry_tags',
        query: currentValue,
        sharedList,
        orderBy,
      }).unwrap();

      return data ?? [];
    } catch (error) {
      return [];
    }
  };

  const onSubmit = ({ industryTags, industryTagsYears }) => {
    const filters = { industryTags };
    if (industryTags && industryTags.length > 0) {
      filters.industryTagsYears = industryTagsYears;
    }
    setFilters(filters);
  };

  const onMenuOpen = () => {
    setIsLoading(true);
    onSearchChange('').then((data) => {
      setDefaultOptions(data);
      setIsLoading(false);
    });
  };

  const getInitialValues = useCallback(
    (industryTags, industryTagsYears) => {
      // If industryTagsYears is just a number, find the matching option
      let normalizedYears = industryTagsYears;
      if (typeof industryTagsYears === 'number') {
        normalizedYears = industryYearsOptions.find((option) => option.value === industryTagsYears);
      }

      return {
        industryTags: industryTags || [],
        industryTagsYears: normalizedYears || industryYearsOptions[0],
      };
    },
    [industryYearsOptions],
  );

  return {
    formSchema,
    industryYearsOptions,
    defaultOptions,
    isLoading,
    onMenuOpen,
    onSearchChange,
    onSubmit,
    getInitialValues,
  };
};
